function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "rgb(0%,0%,0%)",
    fillOpacity: 1
  },
  d: "M 14.285156 10.15625 L 23.21875 0 L 21.101562 0 L 13.34375 8.820312 L 7.148438 0 L 0 0 L 9.371094 13.335938 L 0 23.988281 L 2.117188 23.988281 L 10.308594 14.675781 L 16.851562 23.988281 L 24 23.988281 L 14.28125 10.15625 Z M 11.382812 13.453125 L 10.433594 12.125 L 2.878906 1.558594 L 6.132812 1.558594 L 12.226562 10.085938 L 13.175781 11.414062 L 21.101562 22.5 L 17.847656 22.5 Z M 11.382812 13.453125 "
})));
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.def734ac.svg";